import { useParams } from 'react-router-dom';
import { usePublicProfileQuery } from './queries';
import { PublicService } from './types';
import { useCustomerAuth } from '@features/customer-reservations/CustomerAuthContext';
import {
  useReservationServicesQuery,
  useMyVisitsQuery,
} from '@features/customer-reservations/queries';

export const usePublicProfilePage = () => {
  const { userId } = useParams<{ userId: string }>();
  const {
    isAuthenticated,
    userId: authUserId,
    loading: authLoading,
    logout,
    hasPinSet,
    checkSession,
  } = useCustomerAuth();

  const { data: profile, isLoading: loading, isError } = usePublicProfileQuery(userId);

  const mapsUrl = profile?.address
    ? `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(profile.address)}`
    : null;

  // The URL can contain a public code; the session contains the salon's UUID.
  const isAuthForProfile = isAuthenticated && !!profile?.userId && authUserId === profile.userId;

  // When logged in as this hairdresser's customer, show only allowed services
  const { data: allowedServicesData, isLoading: loadingAllowed } =
    useReservationServicesQuery(isAuthForProfile);

  // Upcoming reservations of the logged-in customer (backend already filters to future)
  const { data: myVisitsData } = useMyVisitsQuery(isAuthForProfile);
  const displayServices: PublicService[] = isAuthForProfile
    ? (allowedServicesData?.services ?? []).map(s => ({
        id: s.id,
        serviceName: s.serviceName,
        publicDescription: s.publicDescription ?? '',
        publicName: s.publicName ?? '',
        basePrice: String(s.basePrice ?? ''),
        blocks: s.blocks ?? [],
      }))
    : (profile?.services ?? []);

  return {
    profile: profile ?? null,
    loading: loading || (isAuthForProfile && loadingAllowed),
    error: isError ? 'Profil se nepodářilo načíst.' : null,
    mapsUrl,
    userId,
    isAuthForProfile,
    authLoading,
    logout,
    displayServices,
    myVisits: myVisitsData ?? [],
    hasPinSet,
    checkSession,
  };
};
